import { shouldPolyfill } from '@formatjs/intl-getcanonicallocales/should-polyfill';

export default async function polyfill() {
    if (shouldPolyfill()) {
        await import('@formatjs/intl-getcanonicallocales/polyfill');
    }
}
